/* istanbul ignore file */
import styled from 'styled-components';
import { Grid } from '@econsult/econsult-ui/dist/components/Grid';
import { Paper } from '@econsult/econsult-ui/dist/components/Paper';
import { HeadingOne, Paragraph } from '@econsult/econsult-ui/dist/components/shared/typography';
import { Button } from '@econsult/econsult-ui/dist/components/Button';

export const GridContainer = styled(Grid)`
  background-color: white;
`;

export const Heading = styled(HeadingOne)`
  font-family: Museo Sans, trebuchet ms, OpenSans, sans-serif;
  margin-top: 0;
  margin-bottom: 1rem;
  font-size: 28px;
  font-weight: 600;
  color: ${({ theme }) => theme.colorPrimaryPrimary100};
`;

export const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 12px;
`;

export const WarningText = styled(Paragraph)`
  font-size: 14px;
  font-weight: 500;
  color: #8A8A8A;
  margin-bottom: 1rem;
  text-align: center;

  strong {
    color: #D0021B;
  }
`;

export const TopBar = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  width: 100%;
`;

export const EditButton = styled.button`
  background: none;
  border: none;
  color: #00638A;
  font-size: 16px;
  text-decoration: underline;
  cursor: pointer;
  display: inline;
  padding: 0;
  margin: 0;

  &:hover {
    color: #004A6E;
  }
`;

export const SummaryHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;

export const BackHomeButton = styled(Button)`
  background-color: #00638A;
  color: #FFFFFF;
  border: 2px solid #00638A;
  padding: 12px 20px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 8px;
  transition: background-color 0.3s ease-in-out, border-color 0.3s ease-in-out;

  &:hover {
    background-color: #004A6E;
    border-color: #004A6E;
  }
`;

export const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 65vh;
  text-align: center;
  position: relative;
`;
